export default __webpack_public_path__ + "static/media/call.0d87dfb1.svg";